import React, {
  useState,
  createContext,
  useContext,
  ReactNode,
  useCallback,
  useEffect,
  useRef,
} from 'react';
import axios from 'axios';

interface GeoAttributes {
  geo_register_button_bg_color: string;
  geo_register_button_text_color: string;
  geo_register_button_shadow_color: string;
  geo_register_button_indication: string;
  geo_show_second_button: boolean;
  geo_second_button_bg_color: string;
  geo_second_button_text_color: string;
  geo_second_button_shadow_color: string;
  geo_second_button_indication: string;
  geo_second_button_url: string;
  geo_position_confirm_button_bg_color: string;
  geo_position_confirm_button_text_color: string;
  geo_position_confirm_button_shadow_color: string;
  geo_position_confirm_button_indication: string;
  geo_position_manual_button_bg_color: string;
  geo_position_manual_button_text_color: string;
  geo_position_manual_button_shadow_color: string;
  geo_position_manual_button_indication: string;
  geo_position_confirm_wizard_indication: string;
  geo_position_show_coordinates_option: boolean;
  geo_position_show_street_option: boolean;
  geo_animation_gradient1_color: string;
  geo_animation_gradient2_color: string;
  geo_animation_indication_text_color: string;
  geo_animation_indication: string;
  geo_verify_range: number;
  geo_verify_success_indication: string;
  geo_verify_failure_indication: string;
  geo_verify_success_show_installation_date: boolean;
  geo_verify_failure_show_installation_date: boolean;
  // Success scenario buttons
  geo_verify_success_first_button_bg_color: string;
  geo_verify_success_first_button_text_color: string;
  geo_verify_success_first_button_shadow_color: string;
  geo_verify_success_first_button_indication: string;
  geo_verify_success_first_button_action: string;
  geo_verify_success_first_button_redirect: string;
  geo_verify_success_first_button_email: string;
  geo_verify_success_second_button_bg_color: string;
  geo_verify_success_second_button_text_color: string;
  geo_verify_success_second_button_shadow_color: string;
  geo_verify_success_second_button_indication: string;
  geo_verify_success_second_button_action: string;
  geo_verify_success_second_button_redirect: string;
  geo_verify_success_second_button_email: string;
  // Failure scenario buttons
  geo_verify_failure_first_button_bg_color: string;
  geo_verify_failure_first_button_text_color: string;
  geo_verify_failure_first_button_shadow_color: string;
  geo_verify_failure_first_button_indication: string;
  geo_verify_failure_first_button_action: string;
  geo_verify_failure_first_button_redirect: string;
  geo_verify_failure_first_button_email: string;
  geo_verify_failure_second_button_bg_color: string;
  geo_verify_failure_second_button_text_color: string;
  geo_verify_failure_second_button_shadow_color: string;
  geo_verify_failure_second_button_indication: string;
  geo_verify_failure_second_button_action: string;
  geo_verify_failure_second_button_redirect: string;
  geo_verify_failure_second_button_email: string;
}

interface BrandStyle {
  header_logo: string;
  header_logo_url: string;

  header_indication: string;
  header_indication_text_color: string;

  recording_button_img: string;
  recording_indication: string;

  stoprecording_button_img: string;
  stop_recording_indication: string;

  holdrecording_button_img: string;
  hold_recording_indication: string;

  text_review_button_bg_color: string;
  text_review_button_text_color: string;
  text_review_button_shadow_color: string;
  text_review_button_indication: string;
  text_review_placeholder_indication: string;
  text_review_send_button_indication: string;
  text_review_back_button_indication: string;

  show_result_text_color: string;

  footer_logo: string;
  footer_logo_url: string;

  product_placeholder_img: string;
  product_placeholder_url: string;

  privacy_policy_text_color: string;
  privacy_policy_indication: string;
  privacy_policy_url: string;

  brand_indication: string;
  product_indication: string;
  product_indication_text_color: string;

  stars_base_color: string;
  stars_gradient1_color: string;
  stars_gradient2_color: string;

  animation_gradient1_color: string;
  animation_gradient2_color: string;

  animation_indication_text_color: string;
  animation_indication: string;

  delete_feedback_button_bg_color: string;
  delete_feedback_button_text_color: string;
  delete_feedback_button_shadow_color: string;
  delete_feedback_button_indication: string;

  // Manage tag button styling fields
  manage_tag_button_bg_color: string;
  manage_tag_button_text_color: string;
  manage_tag_button_shadow_color: string;
  manage_tag_button_indication: string;

  // Manage tag input and selector indication fields
  manage_tag_input_indication: string;
  manage_tag_selector_indication: string;

  // Geo attributes nested object
  geoAttributes: GeoAttributes;

  // CodeScanner styles
  codescanner_button_bg_color: string;
  codescanner_button_text_color: string;
  codescanner_button_shadow_color: string;
  codescanner_button_indication: string;
  codescanner_error_indication: string;
  codescanner_scan_button_bg_color: string;
  codescanner_scan_button_text_color: string;
  codescanner_scan_button_shadow_color: string;
  codescanner_scan_button_indication: string;
  codescanner_upload_button_bg_color: string;
  codescanner_upload_button_text_color: string;
  codescanner_upload_button_shadow_color: string;
  codescanner_upload_button_indication: string;
  codescanner_pistol_button_bg_color: string;
  codescanner_pistol_button_text_color: string;
  codescanner_pistol_button_shadow_color: string;
  codescanner_pistol_button_indication: string;
  codescanner_pistol_error_indication: string;
  codescanner_pistol_input_placeholder: string;
  customer_id_copy_button_bg_color: string;
  customer_id_copy_button_text_color: string;
  customer_id_copy_button_shadow_color: string;
  customer_id_copy_button_indication: string;
  customer_id_restart_button_indication: string;
  customer_id_restart_button_text_color: string;
  skip_product_button_indication: string;
  skip_product_button_text_color: string;
  skip_next_screen_button_indication: string;
  skip_next_screen_button_text_color: string;
  back_button_indication: string;
  back_button_text_color: string;
  photo_feedback_capture_indication: string;
  photo_feedback_add_indication: string;
  photo_feedback_send_indication: string;
  photo_feedback_send_button_bg_color: string;
  photo_feedback_send_button_text_color: string;
  photo_feedback_send_button_shadow_color: string;
  photo_feedback_capture_button_bg_color: string;
  photo_feedback_capture_button_text_color: string;
  photo_feedback_capture_button_shadow_color: string;
}

interface Product {
  id: number;
  code: string;
  redirect_url: string;
  name: string;
  type: string;
  geo_attributes: Record<string, any>;
  serial_number?: string;
  insightgpt_id: number;
  header_logo: string;
  header_indication: string;
  header_logo_url: string;
  product_img: string;
  product_indication: string;
  product_img_url: string;
  remaining_executions: number;
  footer_logo: string;
  footer_logo_url: string;
  privacy_policy_url: string;
  digital_content_placeholder_img: string;
  digital_content_pdf: string;
  redirect_digital_content: string;
  redirect_product: string;
  redirect_with_same_customer_id: boolean;
  show_skip_product_button: boolean;
  show_skip_next_screen_button: boolean;
  back_button_screen_types: string[];
  show_click_and_talk_button: boolean;
  multianswer_selection: boolean;
  multianswer_options: string[];
  multianswer_dropdown_indication: string;
  multianswer_allow_multiple: boolean;
  multianswer_max_answers: number;
  multianswer_exceed_limit_indication: string;
  multianswer_textarea_option: string;
  multianswer_show_free_textarea: boolean;
  multianswer_send_button_indication: string;
  multianswer_send_button_bg_color: string;
  multianswer_send_button_text_color: string;
  multianswer_send_button_shadow_color: string;
  link_options: { code: string; name: string }[];
  links_display_as_buttons: boolean;
}

interface Event {
  id: number;
  header_logo: string;
  header_indication: string;
  header_logo_url: string;
  footer_logo: string;
  footer_logo_url: string;
  privacy_policy_url: string;
  show_delete_feedback_option: boolean;
  assign_feedback_to_user: boolean;
  remember_registration: boolean;
  use_product_placeholder_img: boolean;
  digital_content_placeholder_img: string;
  digital_content_pdf: string;
  redirect_digital_content: string;
}

export interface RegistrationConfig {
  title: string;
  description: string;
  save_button_indication: string;
  save_button_bg_color: string;
  save_button_text_color: string;
  save_button_shadow_color: string;
  fields: any[];
}

// The recorded outcome for a single consent, kept in shared state between the
// consent screen and feedback submission. `version` is echoed back so the server
// can align it with the config it served. `purpose` is a free-form slug defined
// per event/ConsentType, not a fixed set of values.
export interface ConsentOutcome {
  purpose: string;
  granted: boolean;
  version: number;
}

// Device data collected on the device-data screen, kept in shared state and
// added to the feedback payload. purchase_date is only set in the consumer flow.
// adc/months are the consumer-flow alternative to cycle_count (mutually
// exclusive with it): the backend derives cycle_count as adc * months * 30.
export interface DeviceData {
  cycle_count: string;
  codentify: string;
  purchase_date: string;
  adc: string;
  months: string;
}

interface Brand {
  id: number;
  website_url: string;
  header_logo: string;
}

interface User {
  id: number;
  email: string;
  is_employee: boolean;
  employee_permissions: string[];
  token: string;
}

export interface AppContextProps {
  backendBaseUrl: string;
  redirectBaseUrl: string;
  setRedirectBaseUrl: React.Dispatch<React.SetStateAction<string>>;
  appState: string;
  setAppState: React.Dispatch<React.SetStateAction<string>>;
  token: string;
  setToken: React.Dispatch<React.SetStateAction<string>>;
  product: any;
  setProduct: React.Dispatch<React.SetStateAction<any>>;
  isEventMode: boolean;
  // Screen key correntemente mostrato (es. 'consent', 'feedback'), scritto da
  // chi guida la sequenza (ScreenRouter / Body). Serve a chi sta FUORI dal body
  // (Header) per sapere su che screen siamo. null = ancora non risolto.
  currentScreenKey: string | null;
  setCurrentScreenKey: React.Dispatch<React.SetStateAction<string | null>>;
  eventProducts: any[];
  currentProductIndex: number;
  setCurrentProductIndex: React.Dispatch<React.SetStateAction<number>>;
  eventTypeId: number | null;
  eventTypeName: string | null;
  event: any;
  setEvent: React.Dispatch<React.SetStateAction<any>>;
  brand: any;
  setBrand: React.Dispatch<React.SetStateAction<any>>;
  style: any;
  setStyle: React.Dispatch<React.SetStateAction<any>>;
  logoRedirectUrl: string;
  setLogoRedirectUrl: React.Dispatch<React.SetStateAction<string>>;
  globalNotification: [string, string];
  setGlobalNotification: React.Dispatch<React.SetStateAction<[string, string]>>;
  userId: number;
  setUserId: React.Dispatch<React.SetStateAction<number>>;
  userEmail: string;
  setUserEmail: React.Dispatch<React.SetStateAction<string>>;
  user: User | null;
  setUser: React.Dispatch<React.SetStateAction<User | null>>;
  isAuthenticated: boolean;
  setIsAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
  fetchData: () => Promise<void>;
  registerUser: (
    attributes: Record<string, any>,
    eventId: number
  ) => Promise<any>;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
  sessionId: string;
  refreshSessionId: () => void;
  cycleCustomerId: string;
  refreshCycleCustomerId: () => void;
  setCycleCustomerId: React.Dispatch<React.SetStateAction<string>>;
  // session_id condiviso da tutti i feedback del ciclo corrente (vedi FeedbackCycle).
  cycleSessionId: string;
  startNewCycle: () => void;
  getCycleResumeIndex: (productCode: string) => number | null;
  setCycleResumeIndex: (productCode: string, index: number) => void;
  shouldResumeAtFeedback: (productCode: string) => boolean;
  markResumeAtFeedback: (productCode: string) => void;
  associatePendingFeedbacks: (userEmail: string) => Promise<void>;
  resolveMediaUrl: (url: string | null | undefined) => string;
  consents: ConsentOutcome[];
  setConsents: React.Dispatch<React.SetStateAction<ConsentOutcome[]>>;
  deviceData: DeviceData;
  setDeviceData: React.Dispatch<React.SetStateAction<DeviceData>>;
}

const EMPTY_DEVICE_DATA: DeviceData = {
  cycle_count: '',
  codentify: '',
  purchase_date: '',
  adc: '',
  months: '',
};

// ---- Ciclo di feedback ------------------------------------------------------
// Un "ciclo" e' un giro completo del flusso e puo' attraversare PIU' prodotti
// (iterazione per Product.order o catena redirect_product): deve produrre UNA
// riga di feedback per prodotto, tutte con lo STESSO customer_id, gli stessi
// consensi e gli stessi device data.
//
// Ogni salto di prodotto passa da navigate('/?product=NEXT'): la route '/' rende
// Main, non ProductPage, quindi ScreenRouter viene smontato e rimontato da zero.
// Con i dati del ciclo nel solo stato React bastava quel rimontaggio (o un reload)
// per perderli: i prodotti dal secondo in poi partivano senza consensi e il gate
// server-side li rifiutava con 422 — cioe' nessuna riga salvata oltre alla prima,
// in silenzio perche' il save e' fire-and-forget. Stanno quindi in sessionStorage,
// che sopravvive a smontaggi e reload, e si azzerano SOLO con startNewCycle().
interface FeedbackCycle {
  customerId: string;
  sessionId: string;
  consents: ConsentOutcome[];
  deviceData: DeviceData;
  // Screen index da cui ogni prodotto del ciclo deve riprendere: gli screen che
  // raccolgono dati (consent, device data) stanno prima del feedback e si vedono
  // una volta sola per ciclo, quindi i prodotti successivi ripartono dal loro
  // screen di feedback. Passato anche in URL come start_index, ma l'URL viene
  // ripulito subito dopo: questa mappa e' la copia che sopravvive al rimontaggio.
  resumeIndex: Record<string, number>;
  // Prodotti dello stesso ciclo che devono ripartire dal loro screen di feedback
  // senza che l'indice sia noto in anticipo. Serve per la catena redirect_product
  // fuori dall'order dell'evento (order = -1): quei prodotti non sono in
  // eventProducts, quindi il type — e con esso la posizione del feedback nella
  // LORO sequenza — si conosce solo dopo che il prodotto e' caricato. L'indice
  // viene risolto li', sulla sequenza vera, invece di indovinarlo qui.
  resumeAtFeedback: Record<string, boolean>;
}

const CYCLE_STORAGE_KEY = 'yfFeedbackCycle';

function newCycleSessionId(): string {
  return `cs_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

function emptyCycle(): FeedbackCycle {
  return {
    customerId: '',
    sessionId: newCycleSessionId(),
    consents: [],
    deviceData: EMPTY_DEVICE_DATA,
    resumeIndex: {},
    resumeAtFeedback: {},
  };
}

function writeCycle(cycle: FeedbackCycle): void {
  try {
    sessionStorage.setItem(CYCLE_STORAGE_KEY, JSON.stringify(cycle));
  } catch (error) {
    console.warn('Failed to persist the feedback cycle:', error);
  }
}

function readCycle(): FeedbackCycle {
  try {
    const raw = sessionStorage.getItem(CYCLE_STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) || {};
      return {
        customerId:
          typeof parsed.customerId === 'string' ? parsed.customerId : '',
        sessionId:
          typeof parsed.sessionId === 'string' && parsed.sessionId
            ? parsed.sessionId
            : newCycleSessionId(),
        consents: Array.isArray(parsed.consents) ? parsed.consents : [],
        deviceData: { ...EMPTY_DEVICE_DATA, ...(parsed.deviceData || {}) },
        resumeIndex:
          parsed.resumeIndex && typeof parsed.resumeIndex === 'object'
            ? parsed.resumeIndex
            : {},
        resumeAtFeedback:
          parsed.resumeAtFeedback && typeof parsed.resumeAtFeedback === 'object'
            ? parsed.resumeAtFeedback
            : {},
      };
    }
  } catch (error) {
    console.warn('Unreadable feedback cycle, starting a new one:', error);
  }
  const fresh = emptyCycle();
  writeCycle(fresh);
  return fresh;
}

function customerIdFromIndex(idx: number): string {
  const mod = idx % 36000;
  if (mod < 10000) return mod.toString().padStart(4, '0');
  const idx2 = mod - 10000;
  const letterIdx = Math.floor(idx2 / 1000) % 26;
  const digitIdx = idx2 % 1000;
  return `${String.fromCharCode(65 + letterIdx)}${digitIdx.toString().padStart(3, '0')}`;
}

const AppContext = createContext<AppContextProps | undefined>(undefined);

interface AppProviderProps {
  children: ReactNode;
}

export function AppProvider({ children }: AppProviderProps) {
  const fetchDataInFlightRef = React.useRef(false);
  const [appState, setAppState] = useState('loading');
  const [token, setToken] = useState(() => {
    // Check URL first, then sessionStorage
    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get('token');
    return urlToken || sessionStorage.getItem('token') || '';
  });
  const [product, setProduct] = useState<Product | null>(null);
  const [isEventMode, setIsEventMode] = useState<boolean>(false);
  const [currentScreenKey, setCurrentScreenKey] = useState<string | null>(null);
  const [eventProducts, setEventProducts] = useState<any[]>([]);
  const [currentProductIndex, setCurrentProductIndex] = useState<number>(0);
  const [eventTypeId, setEventTypeId] = useState<number | null>(null);
  const [eventTypeName, setEventTypeName] = useState<string | null>(null);
  const [event, setEvent] = useState<Event | null>(null);
  const [brand, setBrand] = useState<Brand | null>(null);
  const [style, setStyle] = useState<BrandStyle | null>(null);
  const [logoRedirectUrl, setLogoRedirectUrl] = useState('');
  const [globalNotification, setGlobalNotification] = useState<
    [string, string]
  >(['', 'success']);
  const [userId, setUserId] = useState<number>(0);
  const [userEmail, setUserEmail] = useState<string>(
    sessionStorage.getItem('userEmail') || ''
  );
  const [user, setUser] = useState<User | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  // Stato del ciclo corrente: customer id, session id, consensi, device data e
  // indici di ripresa per prodotto. Persistito in sessionStorage — vedi FeedbackCycle.
  const [cycle, setCycle] = useState<FeedbackCycle>(readCycle);

  // sessionStorage e' la fonte autorevole e viene scritto in modo SINCRONO, lo
  // stato React e' solo il mirror per il rendering. Serve per il read-after-write:
  // l'indice di ripresa viene scritto subito prima di navigate() e riletto dal
  // mount successivo di ScreenRouter, che non puo' aspettare il commit di React.
  const patchCycle = useCallback(
    (update: (prev: FeedbackCycle) => FeedbackCycle) => {
      const next = update(readCycle());
      writeCycle(next);
      setCycle(next);
    },
    []
  );

  // I setter restano dispatcher React (valore o updater) per non toccare i chiamanti.
  const setConsents = useCallback<
    React.Dispatch<React.SetStateAction<ConsentOutcome[]>>
  >(
    value =>
      patchCycle(prev => ({
        ...prev,
        consents:
          typeof value === 'function'
            ? (value as (p: ConsentOutcome[]) => ConsentOutcome[])(
                prev.consents
              )
            : value,
      })),
    [patchCycle]
  );

  const setDeviceData = useCallback<
    React.Dispatch<React.SetStateAction<DeviceData>>
  >(
    value =>
      patchCycle(prev => ({
        ...prev,
        deviceData:
          typeof value === 'function'
            ? (value as (p: DeviceData) => DeviceData)(prev.deviceData)
            : value,
      })),
    [patchCycle]
  );

  const setCycleCustomerId = useCallback<
    React.Dispatch<React.SetStateAction<string>>
  >(
    value =>
      patchCycle(prev => ({
        ...prev,
        customerId:
          typeof value === 'function'
            ? (value as (p: string) => string)(prev.customerId)
            : value,
      })),
    [patchCycle]
  );

  // Nuovo ciclo: consensi, device data e indici di ripresa azzerati, nuovo
  // session_id e customer_id svuotato (il codice viene ripreso dal contatore al
  // load del prossimo prodotto). E' l'UNICO punto che scarta i dati del ciclo:
  // il cambio di prodotto da solo non li tocca piu'.
  const startNewCycle = useCallback(() => {
    patchCycle(() => emptyCycle());
  }, [patchCycle]);

  // Restart dallo screen customer_id: e' un ciclo nuovo a tutti gli effetti.
  const refreshCycleCustomerId = startNewCycle;

  // Legge da sessionStorage invece che dallo stato per restare stabile come
  // identita': viene usato dentro un layout effect di ScreenRouter, che non deve
  // rieseguire solo perche' la mappa e' cambiata.
  const getCycleResumeIndex = useCallback(
    (productCode: string): number | null => {
      const value = readCycle().resumeIndex[productCode];
      return typeof value === 'number' ? value : null;
    },
    []
  );

  const setCycleResumeIndex = useCallback(
    (productCode: string, index: number) => {
      patchCycle(prev => ({
        ...prev,
        resumeIndex: { ...prev.resumeIndex, [productCode]: index },
      }));
    },
    [patchCycle]
  );

  // "Riparti dal feedback" senza indice: vedi FeedbackCycle.resumeAtFeedback.
  // Come sopra, legge da sessionStorage per restare stabile come identita'.
  const shouldResumeAtFeedback = useCallback(
    (productCode: string): boolean =>
      Boolean(readCycle().resumeAtFeedback[productCode]),
    []
  );

  const markResumeAtFeedback = useCallback(
    (productCode: string) => {
      patchCycle(prev => ({
        ...prev,
        resumeAtFeedback: { ...prev.resumeAtFeedback, [productCode]: true },
      }));
    },
    [patchCycle]
  );

  const consents = cycle.consents;
  const deviceData = cycle.deviceData;
  const cycleCustomerId = cycle.customerId;
  const cycleSessionId = cycle.sessionId;

  const [sessionId, setSessionId] = useState<string>(() => {
    let stored = sessionStorage.getItem('feedbackSessionId');
    if (!stored) {
      stored = `session-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      sessionStorage.setItem('feedbackSessionId', stored);
      console.log('🆔 Generated new session_id:', stored);
    } else {
      console.log('🆔 Using existing session_id:', stored);
    }
    return stored;
  });

  const refreshSessionId = useCallback(() => {
    const newId = `session-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('feedbackSessionId', newId);
    setSessionId(newId);
    console.log('🆔 Refreshed session_id:', newId);
  }, []);

  const currentHostname = window.location.hostname;
  const defaultRedirectBaseUrl =
    currentHostname == 'localhost'
      ? 'http://localhost:5173'
      : `https://${currentHostname}`;
  const [redirectBaseUrl, setRedirectBaseUrl] = useState<string>(
    sessionStorage.getItem('redirectBaseUrl') || defaultRedirectBaseUrl
  );

  // In dev use a same-origin relative base ("/api") so requests go through the
  // Vite proxy to the local backend — mirrors the server setup where Apache
  // proxies /api. On real hosts, keep the absolute https base.
  const backendBaseUrl =
    currentHostname == 'localhost' ? '/api' : `https://${currentHostname}/api`;

  const resolveMediaUrl = (url: string | null | undefined): string => {
    if (!url) return '';
    if (url.startsWith('http://') || url.startsWith('https://')) return url;
    return `${backendBaseUrl}${url}`;
  };

  // Il customer_id e' del CICLO, non del prodotto: viene chiesto al contatore per
  // il primo prodotto del ciclo e riusato da tutti quelli successivi (per order o
  // per catena redirect). Percio' qui NON si azzera nulla al cambio di prodotto:
  // il codice si rinnova solo dopo startNewCycle(), che svuota customerId.
  useEffect(() => {
    const productCode = (product as any)?.code;
    if (!productCode || cycleCustomerId) return;
    let cancelled = false;
    axios
      .get(`${backendBaseUrl}/customer-id-counter`, {
        params: { product: productCode },
      })
      .then(r => {
        if (cancelled) return;
        const idx: number = r.data.next_index ?? 0;
        setCycleCustomerId(r.data.customer_id ?? customerIdFromIndex(idx));
      })
      .catch(() => {
        if (!cancelled) setCycleCustomerId(customerIdFromIndex(0));
      });
    return () => {
      cancelled = true;
    };
  }, [
    backendBaseUrl,
    (product as any)?.code,
    cycleCustomerId,
    setCycleCustomerId,
  ]);

  useEffect(() => {
    sessionStorage.setItem('redirectBaseUrl', redirectBaseUrl);
  }, [redirectBaseUrl]);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const storedIsAuthenticated = localStorage.getItem('isAuthenticated');

    if (
      storedUser &&
      storedUser !== 'undefined' &&
      storedIsAuthenticated === 'true'
    ) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Error parsing stored user:', error);
        // Clear invalid data
        localStorage.removeItem('user');
        localStorage.removeItem('isAuthenticated');
      }
    }
  }, []);

  useEffect(() => {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('isAuthenticated', String(isAuthenticated));
    } else {
      localStorage.removeItem('user');
      localStorage.removeItem('isAuthenticated');
    }
  }, [user, isAuthenticated]);

  const associatePendingFeedbacks = useCallback(
    async (userEmail: string, retryCount = 0) => {
      const maxRetries = 3;
      const retryDelay = 2000; // 2 seconds

      console.log(`\n${'='.repeat(80)}`);
      console.log(
        `🔗 ASSOCIATE_PENDING_FEEDBACKS (Attempt ${retryCount + 1}/${maxRetries + 1})`
      );
      console.log(`Session ID: ${sessionId}`);
      console.log(`User Email: ${userEmail}`);
      console.log(`Backend URL: ${backendBaseUrl}/associate-feedbacks/`);
      console.log(`${'='.repeat(80)}\n`);

      try {
        const payload = {
          session_id: sessionId,
          user_email: userEmail,
        };

        console.log('📤 Sending request with payload:', payload);

        const response = await axios.post(
          `${backendBaseUrl}/associate-feedbacks/`,
          payload
        );

        console.log('📥 Response received:', response.data);

        if (response.data.success) {
          console.log(
            `✅ SUCCESS! Associated ${response.data.associated_count} feedbacks`
          );
          console.log(
            `   Total feedbacks found: ${response.data.total_feedbacks}`
          );

          if (response.data.associated_count > 0) {
            console.log(
              '🎉 Feedbacks successfully associated! Clearing session_id.'
            );
            sessionStorage.removeItem('feedbackSessionId');
          } else if (response.data.total_feedbacks > 0) {
            console.warn(
              '⚠️ Feedbacks exist but none were associated (might already have users)'
            );
          } else {
            console.warn('⚠️ No feedbacks found with this session_id');

            // Retry if no feedbacks found and we haven't exceeded max retries
            if (retryCount < maxRetries) {
              console.log(
                `🔄 Will retry in ${retryDelay}ms (maybe feedbacks are still being saved...)`
              );
              setTimeout(() => {
                associatePendingFeedbacks(userEmail, retryCount + 1);
              }, retryDelay);
            } else {
              console.error(
                '❌ Max retries reached. No feedbacks found to associate.'
              );
            }
          }
        } else {
          console.error(
            '❌ Server returned success=false:',
            response.data.error
          );

          // Retry on failure
          if (retryCount < maxRetries) {
            console.log(`🔄 Will retry in ${retryDelay}ms...`);
            setTimeout(() => {
              associatePendingFeedbacks(userEmail, retryCount + 1);
            }, retryDelay);
          }
        }
      } catch (error: any) {
        console.error('❌ ERROR calling associate-feedbacks:');
        console.error('   Status:', error.response?.status);
        console.error('   Data:', error.response?.data);
        console.error('   Message:', error.message);

        // Retry on error
        if (retryCount < maxRetries) {
          console.log(`🔄 Will retry in ${retryDelay}ms...`);
          setTimeout(() => {
            associatePendingFeedbacks(userEmail, retryCount + 1);
          }, retryDelay);
        } else {
          console.error('❌ Max retries reached. Association failed.');
        }
      }

      console.log(`\n${'='.repeat(80)}\n`);
    },
    [sessionId, backendBaseUrl]
  );

  const fetchData = useCallback(async () => {
    if (fetchDataInFlightRef.current) return;
    fetchDataInFlightRef.current = true;
    try {
      setAppState('loading');
      const urlParams = new URLSearchParams(window.location.search);
      const tokenParam = urlParams.get('token') || '';
      const productParam = urlParams.get('product') || '';
      const eventParam = urlParams.get('event') || '';
      const macParam = urlParams.get('mac') || '';
      const phaseParam = urlParams.get('phase') || '';

      if (eventParam && !productParam && !tokenParam) {
        try {
          const eventResp = await axios.get(
            `${backendBaseUrl}/get-event-info-by-code?event=${encodeURIComponent(eventParam)}`
          );
          const products = (eventResp.data.products || []) as any[];
          setEvent(eventResp.data.event);
          setBrand(eventResp.data.brand);
          setStyle(eventResp.data.style);
          setLogoRedirectUrl(eventResp.data.logoRedirectUrl || '');
          setEventProducts(products);
          setCurrentProductIndex(0);
          setEventTypeId(eventResp.data.event?.event_type_id ?? null);
          setEventTypeName(eventResp.data.event?.event_type_name ?? null);
          setIsEventMode(true);
          setProduct(products.length > 0 ? products[0] : null);
          setAppState('initial');
        } catch (error) {
          console.error('Error getting event info by event code:', error);
          setAppState('error');
        }
        return;
      } else {
        setIsEventMode(false);
        setEventProducts([]);
        setCurrentProductIndex(0);
        setEventTypeId(null);
        setEventTypeName(null);
      }

      if (macParam.trim() !== '' && phaseParam.trim() !== '') {
        const mac = macParam.trim().toLowerCase();
        const macValid = /^[0-9a-f]{2}(:[0-9a-f]{2}){2}$/.test(mac);
        if (!macValid) {
          console.error('Invalid MAC address in URL:', macParam);
          setAppState('error');
          return;
        }
      }

      // Handle token parameter - check if token has product, redirect if yes, show ManageTag if no
      if (tokenParam) {
        setToken(tokenParam);
        sessionStorage.setItem('token', tokenParam);

        try {
          // Check if token already has a product assigned
          const tokenResponse = await axios.get(
            `${backendBaseUrl}/check-token/?token=${tokenParam}`
          );
          if (tokenResponse.data.product) {
            // Token has product assigned - redirect to product page
            window.location.href = `/?product=${tokenResponse.data.product}`;
            return;
          } else {
            // Token has no product - show ManageTag for assignment
            setAppState('managetag');
            return;
          }
        } catch (err) {
          console.error('Failed to check token status:', err);
          // If token check fails, still show ManageTag (fallback behavior)
          setAppState('managetag');
          return;
        }
      }

      if (productParam) {
        try {
          // Check if it's a digital content request
          if (productParam.includes('/digital-content-pdf')) {
            // Extract product code without the digital-content-pdf part
            const productCode = productParam.split('/')[0];
            const prodResp = await axios.get(
              `${backendBaseUrl}/get-product-info-by-code?product=${productCode}`
            );
            setProduct(prodResp.data.product);
            setEvent(prodResp.data.event);
            setBrand(prodResp.data.brand);
            setStyle(prodResp.data.style);
            setLogoRedirectUrl(prodResp.data.logoRedirectUrl || '');
            setAppState('initial');
            return;
          }

          if (macParam.trim() !== '' && phaseParam.trim() !== '') {
            const prodResp = await axios.get(
              `${backendBaseUrl.replace(/\/api$/, '')}/market-test/product-info/?product=${productParam.trim().toLowerCase()}&mac=${macParam
                .trim()
                .toLowerCase()}&phase=${phaseParam.trim().toLowerCase()}`
            );
            const newCode = prodResp.data?.product?.code;
            if (newCode) {
              window.location.href = `/?product=${newCode}`;
              return;
            }
          }

          const prodResp = await axios.get(
            `${backendBaseUrl}/get-product-info-by-code?product=${productParam}`
          );
          setProduct(prodResp.data.product);
          if (prodResp.data.product && prodResp.data.product.redirect_url) {
            let finalUrl = prodResp.data.product.redirect_url;
            if (
              !finalUrl.startsWith('http://') &&
              !finalUrl.startsWith('https://')
            ) {
              finalUrl = 'https://' + finalUrl;
            }
            window.location.replace(finalUrl);
            return;
          } else {
            setEvent(prodResp.data.event);
            setBrand(prodResp.data.brand);
            setStyle(prodResp.data.style);
            setLogoRedirectUrl(prodResp.data.logoRedirectUrl || '');
            setEventTypeId(prodResp.data.event?.event_type_id ?? null);
            setEventTypeName(prodResp.data.event?.event_type_name ?? null);
            // Single-product entry (?product=<code>): NOT event mode. We still expose
            // the event's ordered products (order >= 0) so the feedback screen can
            // navigate to the next product BY URL (?product=<next order>), keeping the
            // URL in sync with the real product instead of iterating in place. The
            // list is re-provided by the backend on every product load, so it stays
            // current across the per-product navigations.
            setEventProducts((prodResp.data.products || []) as any[]);
            setCurrentProductIndex(0);
            setIsEventMode(false);
            setAppState('initial');
          }
        } catch (error: any) {
          console.error('Error getting product info by product code:', error);
          if (error?.response?.status === 404) {
            setAppState('not-found');
          } else {
            setAppState('error');
          }
        }
      }
    } finally {
      fetchDataInFlightRef.current = false;
    }
  }, [backendBaseUrl]);

  const registerUser = async (
    attributes: Record<string, any>,
    eventId: number
  ) => {
    try {
      const response = await axios.post(`${backendBaseUrl}/register-user/`, {
        attributes,
        event_id: eventId,
      });
      if (response.data.success) {
        const email = attributes.email_address || attributes.mail;
        if (email) {
          sessionStorage.setItem('userEmail', email);
          setUserEmail(email);
        }
      }
      return response.data;
    } catch (error) {
      console.error('Registration failed', error);
      throw error;
    }
  };

  const login = async (email: string, password: string) => {
    try {
      const response = await axios.post(`${backendBaseUrl}/login-user/`, {
        email,
        password,
      });

      if (response.data.success) {
        const userData = response.data;
        const newUser: User = {
          id: userData.user_id,
          email: userData.email,
          is_employee: userData.is_employee || false,
          employee_permissions: userData.employee_permissions || [],
          token: '',
        };

        setUser(newUser);
        setUserId(userData.user_id);
        setUserEmail(userData.email);
        setIsAuthenticated(true);

        // Store user data in localStorage
        localStorage.setItem('user', JSON.stringify(newUser));
        localStorage.setItem('isAuthenticated', 'true');
      } else {
        throw new Error(response.data.error || 'Login failed');
      }
    } catch (error: any) {
      console.error('Login error:', error);
      throw error;
    }
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('user');
    localStorage.removeItem('isAuthenticated');
  };

  const store: AppContextProps = {
    backendBaseUrl,
    redirectBaseUrl,
    setRedirectBaseUrl,
    appState,
    setAppState,
    token,
    setToken,
    product,
    setProduct,
    isEventMode,
    currentScreenKey,
    setCurrentScreenKey,
    eventProducts,
    currentProductIndex,
    setCurrentProductIndex,
    eventTypeId,
    eventTypeName,
    event,
    setEvent,
    brand,
    setBrand,
    style,
    setStyle,
    logoRedirectUrl,
    setLogoRedirectUrl,
    globalNotification,
    setGlobalNotification,
    userId,
    setUserId,
    userEmail,
    setUserEmail,
    user,
    setUser,
    isAuthenticated,
    setIsAuthenticated,
    fetchData,
    registerUser,
    login,
    logout,
    sessionId,
    refreshSessionId,
    cycleCustomerId,
    refreshCycleCustomerId,
    setCycleCustomerId,
    cycleSessionId,
    startNewCycle,
    getCycleResumeIndex,
    setCycleResumeIndex,
    shouldResumeAtFeedback,
    markResumeAtFeedback,
    associatePendingFeedbacks,
    resolveMediaUrl,
    consents,
    setConsents,
    deviceData,
    setDeviceData,
  };
  return <AppContext.Provider value={store}>{children}</AppContext.Provider>;
}

export function useAppContext(): AppContextProps {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
}
